/**
 * Query key factory for permissions-related queries
 */
export const permissionKeys = {
  all: () => ['permissions'] as const,
  user: (userId?: string) => [...permissionKeys.all(), 'user', userId] as const,
};
